import { OverlayContainer } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { ContextTooltipContainerDirectiveToken } from '../consts';

@Injectable()
export class ContextTooltipOverlayContainer extends OverlayContainer {
  private readonly platform: Platform;
  private readonly containerDirective = inject(ContextTooltipContainerDirectiveToken);

  constructor() {
    const document = inject<Document>(DOCUMENT);
    const platform = inject(Platform);

    super(document, platform);
    this.platform = platform;

    this._containerElement = this.containerDirective.container;
  }
}
